// src/pages/SavedPage.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { listFormulations } from "../data/store";
import { getLegacyBlacklistSet } from "../data/legacyBlacklist";
import ProductCard from "../components/ProductCard";
import LegacyFormulaCard from "../components/LegacyFormulaCard";
import { useRole } from "../data/useRole";
import "./SavedPage.css";

export default function SavedPage({ items: propsItems, onDelete: propsRemove }) {
  const [items, setItems] = useState([]);
  const [legacyBlacklist, setLegacyBlacklist] = useState(null);
  const { canEdit } = useRole();
  const navigate = useNavigate();

  // Blacklist loading logic (if used)
  const refreshBlacklist = useCallback(() => {
    if (!canEdit) {
      setLegacyBlacklist(null);
      return;
    }
    getLegacyBlacklistSet()
      .then(setLegacyBlacklist)
      .catch(() => setLegacyBlacklist(null));
  }, [canEdit]);

  useEffect(() => {
    refreshBlacklist();
  }, [refreshBlacklist]);

  useEffect(() => {
    if (propsItems) return;
    listFormulations()
      .then(setItems)
      .catch(() => setItems([]));
  }, [propsItems]);

  const handleBlacklisted = () => {
    refreshBlacklist();
  };

  // Filtering logic for legacy blacklist (optional)
  const displayed = (propsItems || items).filter(item => {
    if (!item.legacy) return true;
    if (!legacyBlacklist) return true;
    const key = item.raw || item.color || item.name + (item.info ? JSON.stringify(item.info) : "");
    return !legacyBlacklist.has(key);
  });

  const handleRemove = id => {
    if (propsRemove) {
      propsRemove(id);
    } else {
      setItems(prev => prev.filter(i => i.id !== id));
    }
  };

  // CONVERT HANDLER
  const handleConvert = (formula) => {
    navigate("/convert", { state: { formula } });
  };

  return (
    <section className="sf card">
      <div className="sf__header">
        <h2 className="sf__title">Saved Formulations</h2>
        <p className="sf__subtitle">Click a card to copy its details.</p>
      </div>
      {(!displayed || displayed.length === 0) ? (
        <div className="sf__empty">No saved formulations</div>
      ) : (
        <div className="sf__grid">
          {displayed.map(item =>
            item.legacy ? (
              <LegacyFormulaCard
                key={item.id}
                record={item}
                onBlacklisted={handleBlacklisted}
                onConvert={handleConvert}
              />
            ) : (
              <ProductCard
                key={item.id}
                item={item}
                onRemove={handleRemove}
                onConvert={handleConvert}
              />
            )
          )}
        </div>
      )}
    </section>
  );
}
